<template>
  <VDialog
    class="contract-publication-dialog-component content-block-style"
    closable
  >
    <template #header>
      Публикация договора для {{ contract.type.id === 'seller' ? 'продавца' : 'покупателя' }}
    </template>

    <section>
      <article>
        <VDateInput
          ref="publicationDateInput"
          v-model="publicationDate"
          label="Дата публикации и вступления в силу"
          layout="vertical"
          required
          :validate-method="validatePublicationDate"
          @validate="onValidate($event, 'publicationDate')"
        />
      </article>
    </section>

    <VHelperText>
      <b>Внимание!</b> После нажатия на кнопку "Опубликовать" внесение изменений невозможно
    </VHelperText>

    <template #footer>
      <VButton
        theme="primary"
        @click="publish"
      >
        Опубликовать
      </VButton>
      <VButton @click="closeDialog">
        Отмена
      </VButton>
    </template>
  </VDialog>
</template>

<script lang="ts">

import ContractsPublicService from '@/domains/Contracts/ContractsPublicService';
import ContractPublic         from '@/domains/Contracts/ContractPublic';

import VHelperText     from '@/lib/components/VHelperText/VHelperText.vue';
import ValidationMixin from '@/mixins/validation-mixin';

export default defineComponent({
	name: 'ContractPublicationDialog',

	components: { VHelperText },

	mixins: [ValidationMixin],

	props: {
		contract: {
			type:    Object as PropType<ContractPublic>,
			default: null,
		},
	},

	data() {
		return {
			publicationDate: null as Date | null,
			contracts:       [] as ContractPublic[],
		};
	},

	computed: {
		contractsVersionList(): string[] {
			return this.contracts.map(item => item.version.toString())
				.filter(item => item !== '0');
		},
	},

	mounted() {
		this.loadContracts();
	},

	methods: {
		async loadContracts(): Promise<void> {
			this.contracts = await ContractsPublicService.getList(
				{ id: this.contract.type.id } as ContractPublic['type'],
			);
		},

		async publish(): Promise<void> {
			await this.validate();

			if (!this.isValid) {
				return;
			}

			if (await ContractsPublicService.publish(
				{ id: this.contract.type.id } as ContractPublic['type'],
				this.publicationDate,
			)) {
				this.$emit('publication');
			}
		},

		validatePublicationDate(value: Date): string | null {
			if (!(value instanceof Date)) {
				return null;
			}

			let versionString = value.getFullYear().toString();

			versionString += value.getMonth() < 9 ? `0${value.getMonth() + 1}` : value.getMonth() + 1;
			versionString += value.getDate() < 10 ? `0${value.getDate()}` : value.getDate();

			if (this.contractsVersionList.includes(versionString)) {
				return 'На эту дату уже опубликован договор';
			}

			return null;
		},

		closeDialog(): void {
			this.publicationDate = null;
			this.validationReset();
			this.$emit('close');
		},
	},
});
</script>